module.exports = __webpack_public_path__ + "static/media/login-bg.2f224a0b.jpg";